<form class="schedule-settings-form" [formGroup]="formGroup" ngNativeValidate>
    <mat-grid-list cols="2" rowHeight="95px">
        <mat-grid-tile>
            <div class="container">
                <mat-slide-toggle class="turn-on-slider" [formControl]="isProcessThreadsTTLCheckerActiveControl">
                    Turn On</mat-slide-toggle>
            </div>
        </mat-grid-tile>
        <mat-grid-tile></mat-grid-tile>
        <mat-grid-tile>
            <mat-form-field appearance="fill">
                <mat-label>Threads time to live</mat-label>
                <input matInput type="number" placeholder="e.g. 30" [formControl]="maxProcessThreadTTLMinControl"
                    min="1">
                <span matSuffix class="value-suffix">
                    <mat-icon class="help-icon" [matTooltip]="'Maximum time for thread to work.'">
                        info
                    </mat-icon>Minutes
                </span>
                <mat-error *ngIf="maxProcessThreadTTLMinControl.invalid && maxProcessThreadTTLMinControl.errors.min">Min
                    time: {{minMaxProcessThreadTTLMin}} minutes
                </mat-error>
                <mat-error *ngIf="maxProcessThreadTTLMinControl.invalid && maxProcessThreadTTLMinControl.errors.max">Max
                    time: {{maxMaxProcessThreadTTLMin}} minutes
                </mat-error>
                <mat-error
                    *ngIf="maxProcessThreadTTLMinControl.invalid && maxProcessThreadTTLMinControl.errors.pattern">Only
                    integer numbers allowed
                </mat-error>
            </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile>
            <mat-form-field appearance="fill">
                <mat-label>Threads check Interval</mat-label>
                <input matInput type="number" placeholder="e.g. 30" [formControl]="processTreadsTTLResolutionSecControl"
                    min="0">
                <span matSuffix class="value-suffix">
                    <mat-icon class="help-icon" [matTooltip]="'An interval to ckeck for stuck threads'">
                        info
                    </mat-icon>Seconds
                </span>
                <mat-error
                    *ngIf="processTreadsTTLResolutionSecControl.invalid && processTreadsTTLResolutionSecControl.errors.min">Min
                    interval: {{minProcessTreadsTTLResolutionSec}} seconds
                </mat-error>
                <mat-error
                    *ngIf="processTreadsTTLResolutionSecControl.invalid && processTreadsTTLResolutionSecControl.errors.max">Max
                    interval: {{maxProcessTreadsTTLResolutionSec}} seconds
                </mat-error>
                <mat-error
                    *ngIf="processTreadsTTLResolutionSecControl.invalid && processTreadsTTLResolutionSecControl.errors.pattern">Only
                    numbers allowed
                </mat-error>
            </mat-form-field>
        </mat-grid-tile>
    </mat-grid-list>
</form>
